import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Controller, Discord, HeartFill } from "react-bootstrap-icons";
import "./layout.css";

export function Header() {
    return (
        <Navbar expand="sm" className="site-header">
            <Navbar.Brand as={Link} to="/" className="fw-bold text-foreground">
                skeld.net
            </Navbar.Brand>
            <Nav className="ms-auto site-nav">
                <Nav.Link as={Link} to="/codes" className="text-foreground">
                    <Controller className="me-1 mb-1" />
                    Lobby Browser
                </Nav.Link>
                <Nav.Link href="https://discord.gg/B2Cj6usFBa" className="text-foreground">
                    <Discord className="me-1 mb-1" />
                    Discord
                </Nav.Link>
                <Nav.Link href="https://www.patreon.com/skeld_net" className="text-foreground">
                    <HeartFill className="me-1 mb-1" />
                    Patreon
                </Nav.Link>
            </Nav>
        </Navbar>
    );
}

export function Footer() {
    return (
        <footer className="site-footer text-center">
            <Nav className="justify-content-center">
                <Nav.Link as={Link} to="/privacy" className="text-foreground">
                    Privacy Policy
                </Nav.Link>
                <Nav.Link href="mailto:skeldnet@gmail.com" className="text-foreground">
                    skeldnet@gmail.com
                </Nav.Link>
            </Nav>
            <p className="footer-disclaimer small mb-0">
                Not affiliated with or endorsed by Innersloth LLC.
            </p>
        </footer>
    );
}
